"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./APChip.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var APChip = function APChip(props) {
  var values = props.values,
    onCloseClick = props.onCloseClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ap-chip__wrapper"
  }, values.map(function (value) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "ap-chip__chip",
      key: value
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "ap-chip__chip--text"
    }, value), /*#__PURE__*/_react["default"].createElement("span", {
      className: "ap-chip__chip--close",
      onClick: function onClick() {
        return onCloseClick(value);
      }
    }, "\xD7"));
  }));
};
APChip.defaultProps = {
  value: ''
};
APChip.propTypes = {
  values: _propTypes["default"].array,
  onCloseClick: _propTypes["default"].func
};
var _default = exports["default"] = APChip;